import Styles from "./styles.module.css"

export default function JourneyCard({program, onClick, backgroundColor}){
    const defaultBgColor = "bg-[#f6f1e5]"
    const bgColor = backgroundColor ? backgroundColor : defaultBgColor;
    const cardStyle = `rounded-xl`;
    return(<div className={`${Styles.JourneyCard} ${cardStyle}`} onClick={()=> onClick(program)} style={backgroundColor ? {backgroundColor} : {defaultBgColor}}>
        
            <img src={program.thumb_image} 
                 alt={program.title} 
                 className={Styles.JourneyImage}
            />
        
        <h2>{program.title}</h2>
        <div className={Styles.MetaRow}>
            <span className={Styles.description}>{program.promo_text}</span>
            <span> • </span>
            <span className={Styles.meta}>{program.description}</span>
        </div>
    </div>)
}